import { ensureGeneralFetchInterceptor } from "@moment/state";

/**
 * Install the shared fetch proxy so desktop HTTP(S) requests go through the
 * Rust Tauri command (substitution-aware, bypasses browser CORS). Thin shim
 * over `ensureGeneralFetchInterceptor` — previously this file duplicated the
 * interceptor logic with minor body/bypass-rule divergence; the canonical
 * implementation now lives in `@moment/state`.
 *
 * Must be called BEFORE `createAwsRuntime()` so the effective chain is:
 *   env-var interceptor → AWS interceptor → native fetch.
 */
export const createEnvVarFetchInterceptor = (): void => {
	ensureGeneralFetchInterceptor();
};
